import { AppConfig } from './../../app/app.config';
import { Component } from '@angular/core';
import { SigninService } from '../../services/signin.service';
import { AlertService } from '../../providers/alert.service';
import { SigninPage } from '../signin/signin';
import { NavController } from 'ionic-angular';
import { AgreeMsg } from '../signin/agreemsg';
import { StorageService } from '../../providers/storage.service';
import { CommonService } from '../../services/common.service';
import { WechatSettingModel } from '../../models/wechat.model';

@Component({
    selector: 'wechat',
    templateUrl: 'wechat.html',
    providers: [

    ]
})

export class WechatPage {
    message = "授权验证中..."
    wechatSettings: WechatSettingModel;
    recode: string = "";
    state: string = "";

    constructor(
        private appConfig: AppConfig,
        private navCtrl: NavController,
        private signinService: SigninService,
        private alert: AlertService,
        private localStorage: StorageService,
        private common: CommonService
    ) {
        this.recode = "";
        this.wechatSettings = new WechatSettingModel();
    }

    ionViewDidLoad() {
        this.state = this.common.getParam("state");
        this.recode = this.common.getParam("code");
        this.wechatSettings = this.appConfig.GetWechatSettings();
        if (!this.wechatSettings) {
            this.wechatoAuth();
        } else {
            this.jumpWechatUrl();
        }
    }

    wechatoAuth() {
        this.common.oAuth().then((res: WechatSettingModel) => {
            if (res) {
                this.wechatSettings = res;
                this.localStorage.write("wechatsettings", this.wechatSettings);
            } else {
                this.navCtrl.push(SigninPage);
            }
        }).then(() => {
            this.jumpWechatUrl();
        }).catch((err) => {
            document.getElementById("errorMessage").innerHTML = err;
        })
    }

    jumpWechatUrl() {
        if (!this.state) {
            this.state = new Date().getTime() + "";
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="
                + this.wechatSettings.WxAppID + "&redirect_uri="
                + this.wechatSettings.WapJumpUrl + "&response_type=code&scope=snsapi_userinfo&state="
                + this.state + "#wechat_redirect";
        } else {
            this.login(this.recode, this.state);
        }
    }

    login(code, state) {
        let that = this;
        this.signinService.oAuthLogin(code, state).then(s => {
            if (s.Result == 2) {
                that.alert.alert({
                    title: "此微信没有绑定用户账号，请用账号登陆！",
                    button: [{
                        text: "确认",
                        handler: () => {
                            that.navCtrl.push(SigninPage);
                        }
                    }]
                });
            } else if (s.Result == 4) {
                that.alert.alert({
                    title: "抱歉哦，该账号已经被禁用...",
                    button: [{
                        text: "确认",
                        handler: () => {
                            that.navCtrl.push(SigninPage);
                            let timer = setTimeout(() => {
                                clearTimeout(timer);
                            }, 800);
                        }
                    }]
                });
            } else if (s.Result == 6) {
                that.alert.alert({
                    title: "系统异常，正在重试...",
                    button: [{
                        text: "确认",
                        handler: () => {
                            that.navCtrl.push(SigninPage);
                        }
                    }]
                });

            } else if (s.Result == 0) {
                this.localStorage.writeString("token", s.Token);
                this.signinService.getUserModel().then(user => {
                    this.navCtrl.push(AgreeMsg, {
                        user: user,
                        token: s.Token,
                        users: { username: s.UserName }
                    });
                });
            }
        }).catch(err => {
            this.alert.alert({
                title: JSON.parse(err._body).ExceptionMessage,
                buttons: [{
                    text: "确认",
                    handler: () => {
                        that.navCtrl.push(SigninPage);
                    }
                }]
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/wechat/wechat.ts